exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".FiveBlockLinksForDriving-a:hover{-webkit-transition:all .15s;transition:all .15s}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/FiveBlockLinksForDriving/src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.l.scss"],"names":[],"mappings":"AAGE,kCAEI,4BAA6B,AAC7B,mBAAqB,CACtB","file":"FiveBlockLinksForDriving.l.scss","sourcesContent":["@import '~scss/variables';\n\n.FiveBlockLinksForDriving {\n  &-a {\n    &:hover {\n      -webkit-transition: all 150ms;\n      transition: all 150ms;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.l.scss
// module id = 916
// module chunks = 139